import * as React from 'react';
import { theme } from '@packages/ui';
import { ModuleAd } from '@packages/common';
import { GoogleAds } from '@packages/shared';

export type AdProps = ModuleAd;

export const Ad: React.FC<AdProps> = ({ adUnitPath, sizes }) => (
  <GoogleAds
    maxWidth={theme.content.cmsModuleMaxWidth}
    enableSingleRequest={true}
    adUnitPath={adUnitPath}
    sizes={sizes}
  />
);
